import React from 'react';
import { Item, Stagger } from './Reveal';

export default function About() {
  return (
    <section id="about" className="bg-paper-2 py-24 lg:py-32">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 sm:px-8 lg:grid-cols-[1.05fr_1fr] lg:gap-20 lg:px-12">
        <Stagger amount={0.2} className="relative">
          <Item className="overflow-hidden rounded-xl shadow-card">
            <img
              src="/images/reading.jpg"
              alt="A woman reading a book in a softly lit room"
              className="aspect-[4/3] w-full object-cover lg:aspect-[5/4]"
              loading="lazy"
            />
          </Item>
          <Item className="absolute -bottom-8 right-4 max-w-[17rem] rounded-lg bg-ink p-5 text-paper shadow-float sm:-right-6 lg:-right-10">
            <p className="font-serif text-[1.35rem] italic leading-snug">
              &ldquo;Unlock your true potential and embrace the journey of inspiration.&rdquo;
            </p>
          </Item>
        </Stagger>

        <Stagger className="space-y-6 pt-6 lg:pt-0">
          <Item as="p" className="eyebrow">About us</Item>
          <Item as="h2" className="text-4xl font-normal leading-[1.05] tracking-[-0.045em] text-balance sm:text-5xl">
            Your partner on the{' '}
            <span className="font-serif italic tracking-[-0.02em] text-sage-deep">journey</span> to new heights
          </Item>
          <Item as="p" className="text-[1.02rem] leading-relaxed text-ink-soft">
            Welcome to Y.S.E Media &mdash; where we are passionate about empowering businesses to thrive in the
            digital landscape. Our journey began with a vision to provide unmatched online marketing solutions,
            tailored to elevate businesses of all sizes towards their aspirations.
          </Item>
          <Item as="p" className="text-[1.02rem] leading-relaxed text-ink-soft">
            With a team of dedicated professionals, we go above and beyond to ensure our clients receive
            top-quality service. Embracing the latest trends and technologies in digital marketing, we craft
            bespoke strategies that deliver tangible results.
          </Item>
          <Item className="flex items-center gap-4 border-t border-line pt-6">
            <span className="inline-flex size-12 items-center justify-center rounded-[4px] bg-ink font-slab text-2xl font-extrabold text-paper">
              Y
            </span>
            <span className="text-sm leading-snug text-ink-soft">
              <span className="block font-semibold text-ink">Y.S.E Holdings Ltd</span>
              Headquartered in Limassol, Cyprus
            </span>
          </Item>
        </Stagger>
      </div>
    </section>
  );
}
